import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from '@/App';
import { preloadMarketingPage } from '@/marketingPages';
import { initAnalytics } from '@/lib/analytics/track';
import { initErrorTracking } from '@/lib/analytics/errors';
import { captureVisitSource } from '@/lib/analytics/visitSource';
import '@/lib/zodConfig';
import './index.css';

initAnalytics();
initErrorTracking();
captureVisitSource();

const rootElement = document.getElementById('root')!;
// A prerendered snapshot is already on screen. Fetch its page's code first, so React's
// first render swaps in the same page rather than a loading spinner. If that fails, the
// page loads the normal lazy way.
const pageReady = rootElement.hasChildNodes() ? preloadMarketingPage(window.location.pathname) : null;
void (pageReady ?? Promise.resolve())
  .catch(() => undefined)
  .then(() => {
    createRoot(rootElement).render(
      <StrictMode>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </StrictMode>
    );
  });